export default {
      id: "sli-help-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.43681d49.svg#sli-help",
      toString: function () {
        return this.url;
      }
    }